<template>
  <cTable ref="form" :methods="methods" :form="form"> </cTable>
</template>

<script>
import {
  operSeaOrder,
  getShipCompany,
  getBillType,
  getContainerType,
  getPort,
  airway_number,
  searchCustomer,
} from "@/api/tracker/sea";
import { getCustomer } from "@/api/tracker/air";
import {
  getTransportAgent,
  getLoadType,
  getShippingMode,
} from "@/api/tracker/air";
import { getAllClient } from "@/api/user/client";
import { dblpackingOrder } from "@/api/packing/packing";
import cTable from "@/base/common/index";
export default {
  name: "newSeaWaybill",
  components: {
    cTable,
  },
  watch: {
    // selData: {
    //   handler: function(nowVal) {
    //     this.form.fields.forEach(async (el, idx) => {
    //       if (el.key == "extract-load_type" || el.key == "relation-load_type") {
    //         el.options = nowVal.loadList;
    //       }
    //       if (
    //         el.key == "extract-clearance_agent_id" ||
    //         el.key == "relation-clearance_agent_id"
    //       ) {
    //         el.options = nowVal.transportAgent;
    //       }
    //       if (
    //         el.key == "extract-shipping_mode" ||
    //         el.key == "relation-shipping_mode"
    //       ) {
    //         el.options = nowVal.shippingMode;
    //       }
    //       if (
    //         el.key == "extract-from_station" ||
    //         el.key == "relation-from_station"
    //       ) {
    //         el.options = nowVal.packingAir;
    //       }
    //       if (
    //         el.key == "extract-to_station" ||
    //         el.key == "relation-to_station"
    //       ) {
    //         el.options = nowVal.country;
    //       }
    //     });
    //   },
    //   deep: true
    // }
  },
  async mounted() {
    let res = (await getTransportAgent()).data.payload;
    this.form.fields.forEach((el) => {
      if (
        el.key == "safety_agent" ||
        el.key == "baoguan_agent" ||
        el.key == "clearance_agent_id" ||
        el.key == "delivery" ||
        el.key == "file_agent" ||
        el.key == "loading_agent"
      ) {
        el.options = res;
      }
    });
  },
  methods: {},
  data() {
    let that = this;
    return {
      selData: {
        loadList: [],
        transportAgent: [],
        shippingMode: [],
        country: [],
        packingAir: [],
      },
      methods: {
        getShipCompany,
        getBillType,
        getContainerType,
        operSeaOrder,
        getTransportAgent,
        getLoadType,
        getShippingMode,
        dblpackingOrder,
        getPort,
        getCustomer,
        airway_number,
      },
      form: {
        config: {
          modalBind: {
            width: 600,
          },
          formBind: {
            labelWidth: 140,
          },
          rowBind: {
            gutter: 13,
            style: {
              marginBottom: "20px",
            },
          },
          rules: {
            client_id: [
              {
                required: true,
                message: "name cannot be empty",
              },
            ],
            airway_number: [
              {
                required: false,
                // type: "array",
                message: "name cannot be empty",
                trigger: "change",
              },
            ],
            mawb: [
              {
                required: true,
                type: "string",
                message: "cabinetNumber cannot be empty",
                trigger: "blur",
              },
            ],
            from_station: [
              {
                required: true,
                type: "string",
                message: "please select from station",
                trigger: "change",
              },
            ],
            to_station: [
              {
                required: true,
                type: "string",
                message: "please select to station",
                trigger: "change",
              },
            ],
            dept_date: [
              {
                required: true,
                type: "date",
                message: "dept date cannot be empty",
                trigger: "change",
              },
            ],
            expected_date: [
              {
                required: true,
                type: "date",
                message: "expected date cannot be empty",
                trigger: "change",
              },
            ],
            billingMethod: [
              {
                required: true,
                type: "string",
                message: "load type cannot be empty",
                trigger: "change",
              },
            ],
            load_type: [
              {
                required: false,
                type: "string",
                message: "load type cannot be empty",
                trigger: "change",
              },
            ],
            issue_mode: [
              {
                required: true,
                type: "string",
                message: "issue mode cannot be empty",
                trigger: "change",
              },
            ],
            volume: [
              {
                required: true,
                type: "string",
                message: "volume cannot be empty",
                trigger: "blur",
              },
            ],
            weight: [
              {
                required: true,
                type: "string",
                message: "weight cannot be empty",
                trigger: "blur",
              },
            ],
            items: [
              {
                required: true,
                type: "string",
                message: "items cannot be empty",
                trigger: "blur",
              },
            ],
            // sea_agent: [
            //   {
            //     required: false,
            //     type: "number",
            //     message: "clearagent agent cannot be empty",
            //     trigger: "change",
            //   },
            // ],
            remarks: [
              {
                required: false,
                type: "string",
                message: "remarks cannot be empty",
                trigger: "blur",
              },
            ],
            cabinet_type: [
              {
                required: true,
                type: "string",
                message: "cabinet type cannot be empty",
                trigger: "change",
              },
            ],
            seal: [
              {
                required: true,
                type: "string",
                message: "seal cannot be empty",
                trigger: "blur",
              },
            ],
            goods_name: [
              {
                required: true,
                type: "string",
                message: "productName cannot be empty",
                trigger: "blur",
              },
            ],
            booking_number: [
              {
                required: true,
                type: "string",
                message: "booking number cannot be empty",
                trigger: "blur",
              },
            ],
            shipping_company: [
              {
                required: true,
                type: "string",
                message: "shipping company cannot be empty",
                trigger: "change",
              },
            ],
          },
        },
        grid: [
          // {
          //   name: "中港单号",
          //   children: [{ packing_number: 24 }]
          {
            client_id: 8,
            mawb: 8,
            from_station: 8,
          },
          {
            to_station: 8,
            dept_date: 8,
            expected_date: 8,
          },
          {
            volume: 8,
            weight: 8,
            items: 8,
          },
          {
            issue_mode: 8,
            cabinet_type: 8,
            seal: 8,
          },
          {
            goods_name: 8,
            booking_number: 8,
            shipping_company: 8,
          },
          {
            load_type: 8,
            sea_agent: 8,
            baoguan_agent: 8,
          },
          {
            clearance_agent_id: 8,
            delivery: 8,
            safety_agent: 8,
          },
          {
            file_agent: 8,
            loading_agent: 8,
          },
          {
            remarks: 24,
          },
          {
            airway_number: 12,
            ids: 12,
          },
          {
            button: 10,
          },
        ],
        fields: [
          {
            key: "ids",
            name: () => this.$t("B2bOrderNo"),
            // component: "Select",
            placeholder() {
              return;
            },
            options: [],
            default: [],
            render: (h, { field, row }) => {
              return h("div", {}, [
                field.options.length
                  ? h(
                      "a",
                      {
                        on: {
                          click: () => {
                            if (row[field.key].length === field.options.length)
                              return (row[field.key] = []);
                            row[field.key] = field.options.map((t) => t.value);
                          },
                        },
                      },
                      row[field.key].length === field.options.length
                        ? "取消全选"
                        : "全选"
                    )
                  : "",
                h(
                  "Select",
                  {
                    attrs: {
                      value: row[field.key],
                      "max-tag-count": 4,
                      multiple: true,
                      disabled: !row.airway_number,
                      placeholder:
                        this.$t("enter") +
                        this.$t("markField") +
                        this.$t("search"),
                    },
                    on: {
                      "on-change"(value) {
                        row[field.key] = value;
                      },
                    },
                  },
                  field.options.map((t) =>
                    h(
                      "Option",
                      { attrs: { value: t.value, key: t.value } },
                      t.label
                    )
                  )
                ),
              ]);
            },
          },
          {
            key: "client_id",
            name: () => this.$t("clientName"),
            component: "AutoComplete",
            placeholder() {
              return this.$t("enter") + this.$t("clientName");
            },
            data: [],
            methods: {
              "on-search": ({field, value}) => {
                if (value.length >= 2) {
                  searchCustomer(value).then(res => {
                    field.data = res.data.payload
                  })
                }
              }
            },
            // data: [],
          },
          {
            key: "mawb",
            name: () => this.$t("cabinetNumber"),
            component: "Input",
            placeholder() {
              return this.$t("enter") + this.$t("cabinetNumber");
            },
          },
          {
            key: "from_station",
            name: () => this.$t("target_airport"),
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("target_airport");
            },
            options: [],
            methods: {
              async list({ field, searchForm }) {
                let res = (await getPort({ type: 1 })).data.payload;
                field.options = res;
                this.$forceUpdate();
              },
            },
          },
          {
            key: "to_station",
            name: () => this.$t("to_station"),
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("to_station");
            },
            options: [],
            methods: {
              async list({ field, searchForm }) {
                let res = (await getPort({ type: 2 })).data.payload;
                field.options = res;
                this.$forceUpdate();
              },
            },
          },
          {
            key: "dept_date",
            name: () => this.$t("dept_date"),
            component: "DatePicker",
            disabledDate: true,
            bind: {
              type: "datetime",
            },
            placeholder() {
              return this.$t("select") + this.$t("dept_date");
            },
          },
          {
            key: "expected_date",
            name: () => this.$t("expected_date"),
            component: "DatePicker",
            disabledDate: true,
            bind: {
              type: "datetime",
            },
            placeholder() {
              return this.$t("select") + this.$t("expected_date");
            },
          },
          {
            key: "load_type",
            name: () => this.$t("load_type"),
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("load_type");
            },
            options: [],
            methods: {
              async list({ field, searchForm }) {
                let res = (await getLoadType()).data.payload;
                field.options = res;
                this.$forceUpdate();
              },
            },
          },
          {
            key: "issue_mode",
            name: () => this.$t("billingMethod"),
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("billingMethod");
            },
            options: [],
            methods: {
              async list({ field, searchForm }) {
                let res = (await getBillType()).data.payload;
                field.options = res;
                this.$forceUpdate();
              },
            },
          },
          {
            key: "volume",
            name: () => this.$t("size") + "(CBM)",
            component: "Input",
            bind: {
              type: "number",
            },
            placeholder() {
              return this.$t("enter") + this.$t("size") + "(CBM)";
            },
          },
          {
            key: "weight",
            name: () => this.$t("Weight"),
            component: "Input",
            bind: {
              type: "number",
            },
            placeholder() {
              return this.$t("enter") + this.$t("Weight");
            },
          },
          {
            key: "items",
            name: () => this.$t("invoicePCS"),
            component: "Input",
            bind: {
              type: "number",
            },
            placeholder() {
              return this.$t("enter") + this.$t("invoicePCS");
            },
          },
          {
            key: "sea_agent",
            name: () => this.$t("shipAgent"),
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("shipAgent");
            },
            options: [],
            methods: {
              async list({ field, searchForm }) {
                let res = (await getTransportAgent({ type: "sea" })).data
                  .payload;
                field.options = res;
                this.$forceUpdate();
              },
            },
          },
          {
            key: "safety_agent",
            name: () => this.$t("safetyAgent"),
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("safetyAgent");
            },
            options: [],
            // methods: {
            //   async list({ field, searchForm }) {
            //     let res = (await getTransportAgent()).data
            //       .payload;
            //     field.options = res;
            //     this.$forceUpdate();
            //   },
            // },
          },
          {
            key: "baoguan_agent",
            name: () => this.$t("TrailerCustomsBroker"),
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("TrailerCustomsBroker");
            },
            options: [],
            // methods: {
            //   async list({ field, searchForm }) {
            //     let res = (await getTransportAgent()).data.payload;
            //     field.options = res;
            //     this.$forceUpdate();
            //   },
            // },
          },
          {
            key: "clearance_agent_id",
            name: () => this.$t("clearagent"),
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("clearagent");
            },
            options: [],
            // methods: {
            //   async list({ field, searchForm }) {
            //     let res = (await getTransportAgent()).data.payload;
            //     field.options = res;
            //     this.$forceUpdate();
            //   },
            // },
          },
          {
            key: "file_agent",
            name: () => this.$t("fileAgent"),
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("fileAgent");
            },
            options: [],
            // methods: {
            //   async list({ field, searchForm }) {
            //     let res = (await getTransportAgent()).data.payload;
            //     field.options = res;
            //     this.$forceUpdate();
            //   },
            // },
          },
          {
            key: "loading_agent",
            name: () => this.$tz("装柜,代理"),
            component: "Select",
            placeholder() {
              return this.$tz("装柜,代理");
            },
            options: [],
          },
          {
            key: "delivery",
            name: () => this.$t("distribution_agent"),
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("distribution_agent");
            },
            options: [],
            // methods: {
            //   async list({ field, searchForm }) {
            //     let res = (await getTransportAgent()).data.payload;
            //     field.options = res;
            //     this.$forceUpdate();
            //   },
            // },
          },
          {
            key: "remarks",
            name: () => this.$t("order_desc"),
            component: "Input",
            bind: {
              type: "textarea",
              rows: 2,
            },
            placeholder() {
              return this.$t("select") + this.$t("order_desc");
            },
          },
          {
            key: "cabinet_type",
            name: () => this.$t("cabinet_type"),
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("cabinet_type");
            },
            options: [],
            methods: {
              async list({ field, searchForm }) {
                let res = (await getContainerType()).data.payload;
                field.options = res;
                this.$forceUpdate();
              },
            },
          },
          {
            key: "seal",
            name: () => this.$t("seal"),
            component: "Input",
            placeholder() {
              return this.$t("enter") + this.$t("seal");
            },
          },
          {
            key: "goods_name",
            name: () => this.$t("productName"),
            component: "Input",
            placeholder() {
              return this.$t("enter") + this.$t("productName");
            },
          },
          {
            key: "booking_number",
            name: () => this.$t("booking_number"),
            component: "Input",
            placeholder() {
              return this.$t("enter") + this.$t("booking_number");
            },
          },
          {
            key: "shipping_company",
            name: () => this.$t("shipping_company"),
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("shipping_company");
            },
            options: [],
            methods: {
              async list({ field, searchForm }) {
                let res = (await getShipCompany()).data.payload;
                field.options = res;
                this.$forceUpdate();
              },
            },
          },
          {
            key: "airway_number",
            name: () => this.$t("markField"),
            component: "Input",
            bind: {
              // multiple: true,
              type: "textarea",
              rows: 4,
            },
            placeholder() {
              return this.$t("enter") + this.$t("markField");
            },
            // options: [],
            methods: {
              "on-blur"({ value, fields }) {
                console.log(value, fields);
                fields.find((t) => {
                  if (t.key === "ids") {
                    this.$page
                      .handleRequestMethods("airway_number", {
                        airway_number: value,
                      })
                      .then((res) => {
                        t.options = res.payload;
                      });
                    return true;
                  }
                });
              },
            },
          },
        ],
        buttons: [
          {
            name: () => this.$t("order_submit"),
            bind: {
              style: "width:150px",
              type: "primary",
              icon: "md-add",
            },
            isSub: true,
            methods: {
              click({ grid, formData, buttons }) {
                let data = {};
                for (const key in formData) {
                  if (key === "dept_date" || key === "expected_date") {
                    data[key] = formData[key]
                      ? this.$page.format.timeFormat(
                          formData[key],
                          "YYYY-MM-DD HH:mm:ss"
                        )
                      : "";
                  } else {
                    data[key] = formData[key];
                  }
                }
                data["method"] = "post";
                this.$page
                  .handleRequestMethods("operSeaOrder", data, true)
                  .then((res) => {
                    this.$refs["form"].resetFields();
                  });
                // console.log("formData", grid, formData);
              },
            },
          },
        ],
      },
    };
  },
};
</script>
<style type="text/css">
/* @page{
    size: 7cm 8cm;
  } */
</style>
<style lang="scss" scoped></style>
